// src/components/modals/ConfirmModal.jsx
import React from 'react';
import Modal from '../common/Modal';
import './ConfirmModal.css';

const ConfirmModal = ({ 
    isOpen, 
    onClose, 
    onConfirm, 
    title = 'Подтверждение', 
    message, 
    confirmText = 'Ok',
    cancelText = 'Отмена',
    danger = false,
    warning 
}) => {
    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title={title}
            size="small"
            footer={
                <>
                    <button className="btn-cancel" onClick={onClose}>
                        {cancelText}
                    </button>
                    <button 
                        className={danger ? 'btn-danger' : 'btn-save'} 
                        onClick={onConfirm}
                    >
                        {confirmText}
                    </button>
                </>
            }
        >
            <p>{message}</p>
            {warning && <p className="warning-text">⚠️ {warning}</p>}
        </Modal>
    );
};

export default ConfirmModal;